import useAnamConvaiClient from '../../hooks/useAnamConvaiClient';
import useVoiceModeListener from '../../hooks/useVoiceModeListener';

function AnamConvaiClient({
  aiResponsePlaybackActiveRef,
  isVideoStreamReady,
  handleSendAudioChunk,
  handleEndAudioSequence
}) {
  useAnamConvaiClient({
    aiResponsePlaybackActiveRef,
    isVideoStreamReady,
    handleSendAudioChunk,
    handleEndAudioSequence
  });
  useVoiceModeListener();

  return null;
}

export default AnamConvaiClient;
